import React from 'react';
import PropTypes from 'prop-types';
import {
  compose,
  pure,
  withProps,
  setPropTypes,
  defaultProps
} from 'recompose';

const Truncate = ({ className, text, truncate }) => (
  <p className={className}>
    {text} {truncate ? <span>[...]</span> : false}
  </p>
);

function truncateText(text, maxlength) {
  if (!text) {
    return null;
  }

  if (text.length <= maxlength) {
    return text;
  }

  const trimmedString = text.substr(0, maxlength);

  return trimmedString.substr(
    0,
    Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))
  );
}

function checkTruncate(text, maxlength) {
  if (!text) {
    return false;
  }

  if (text.length > maxlength) {
    return true;
  }
  return false;
}

export default compose(
  setPropTypes({
    text: PropTypes.string.isRequired,
    truncate: PropTypes.bool,
    maxlength: PropTypes.number.isRequired,
    disabled: PropTypes.bool
  }),
  defaultProps({
    maxlength: 100
  }),
  withProps(({ text, maxlength, disabled }) => ({
    text: disabled ? text : truncateText(text, maxlength),
    truncate: disabled ? false : checkTruncate(text, maxlength)
  })),
  pure
)(Truncate);
